import {FileUpload} from 'components/FileUpload';
import {getAcceptString, MAX_SIZE} from 'lib/ImageValidators';
import {comparableTypes} from 'lib/PropertyUtils';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

const mapStateToProps = (state, { className, propertyId, style }) => {
  return {
    className,
    header: 'Add new property image',
    description: <span>Drag and drop or <strong><u>browse</u></strong> your files<br/>(JPG or PNG)</span>,
    accept: getAcceptString(),
    maxSize: MAX_SIZE,
    uploadProgress: state.uploadProgress,
    uploadText: 'Uploading image...',
    propertyId: propertyId || state.propertyDetail.propertyId,
    isTargetProperty: !propertyId || state.propertyDetail.propertyId === propertyId,
    style,
  };
};

const mapDispatchToProps = (dispatch, { onUpload, onReject }) => ({
  onUpload: (files, event) => {
    const eventType = event.type;
    onUpload && onUpload(files, eventType);
  },
  onReject: (files = []) => {
    // Only assumes the first error is relevant
    const errors = files.flatMap(f => {
      const errorCode = f.errors[0]?.code ?? 'unknown';
      let msg;
      switch (errorCode) {
        case 'file-too-large':
          msg = 'File size greater than 10mb.';
          break;
        case 'file-invalid-type':
          msg = 'File type not supported.';
          break;
        default:
          msg = 'Unknown error.';
          console.error(f.errors[0]?.code);
          break;
      }
      return [msg];
    });
    if (errors.length < 1) {
      errors.push('Unknown error.');
    }
    onReject && onReject(errors);
  },
});

const mergeProps = (stateProps, dispatchProps) => ({
  ...stateProps,
  ...dispatchProps,
});

/**
 * Container for property image uploads. This has different behavior from other image upload fields, since the
 * responsibility for the image upload is passed to the parent component.
 * @param comparableType one of 'sales', 'listings', 'rentals'
 * @param objectContext used to inform the Mixpanel event the context used
 */
const ImageUploadContainer = connect(mapStateToProps, mapDispatchToProps, mergeProps)(FileUpload);

ImageUploadContainer.propTypes = {
  comparableType: PropTypes.oneOf(comparableTypes),
  objectContext: PropTypes.string,
  onUpload: PropTypes.func,
  onReject: PropTypes.func,
  pageContext: PropTypes.string,
  propertyId: PropTypes.number,
  style: PropTypes.object,
};
ImageUploadContainer.defaultProps = {
  objectContext: 'Target Property',
  pageContext: 'Target Property',
};
export default ImageUploadContainer;